var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import mediaQueries from "syf-component-library/const/mediaQueries";
import { fontSizes, spacing } from "syf-component-library/defaultTheme";
import { Body } from "syf-component-library/ui";
var StepContent = styled(Body)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  font-size: ", "px;\n  width: 220px;\n  position: relative;\n  right: ", "px;\n  text-align: center;\n  @media ", " {\n    text-align: left;\n    right: 3px;\n  }\n"], ["\n  display: block;\n  font-size: ", "px;\n  width: 220px;\n  position: relative;\n  right: ", "px;\n  text-align: center;\n  @media ", " {\n    text-align: left;\n    right: 3px;\n  }\n"])), function (_a) {
    var $primary = _a.$primary;
    return ($primary ? 14 : fontSizes.small);
}, spacing.large, mediaQueries.lessThanMedium);
export default StepContent;
var templateObject_1;
//# sourceMappingURL=StepContent.js.map